export const routes = (prefix) => [
    {
        path: `/${prefix}/employee-setup/employees`,
        name: `${prefix}.employee-setup.employees.index`,
        component: () => import('./employees/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.employee-setup.employees.index`,
                PageDescription: "Employees Listing/Create",
            }
        }
    },
];
